<template>
  <div class="chat-bubble" :class="direction">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
export type ChatBubbleDirection = 'incoming' | 'outgoing';

defineProps<{ direction: ChatBubbleDirection }>();
</script>

<style scoped lang="scss">
.chat-bubble {
  padding: 0.625rem 0.875rem;
  font-size: 0.84375rem;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  // The tight corner sits on the speaker's side, like the tail of a speech bubble.
  &.incoming {
    background: var(--t-color-neutral-100);
    color: var(--t-color-neutral-950);
    border-radius: 0.25rem 0.875rem 0.875rem 0.875rem;
  }

  &.outgoing {
    background: var(--t-color-neutral-950);
    color: var(--t-color-neutral-50);
    border-radius: 0.875rem 0.25rem 0.875rem 0.875rem;
  }
}
</style>
